
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Footer',
  data() {
    return {

    };
  },
  props: ['payInfo'],
  components: {
  },
  methods: {
    handleToPay() {
      this.$emit('handleToPay');
    },
  },
});
